import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

export interface EmailValidationConfig {
  invalidDomains: string[];
  invalidTlds: string[];
}

@Injectable({ providedIn: 'root' })
export class EmailValidationConfigService {

  private config!: EmailValidationConfig;

  constructor(private http: HttpClient) {}

  load(): Promise<void> {
    return this.http
      
    // .get<EmailValidationConfig>('assets/config/email-domains.json')
    .get<EmailValidationConfig>(window["ActDatosCciales"].ModuleDirectory + 'wwwroot/assets/config/email-domains.json')
    .toPromise()
      .then(cfg => {
        this.config = {
          invalidDomains: cfg.invalidDomains.map(d => d.toLowerCase()),
          invalidTlds: cfg.invalidTlds
        };
      });
  }

  get invalidDomains(): string[] {
    return this.config?.invalidDomains ?? [];
  }

  get invalidTlds(): string[] {
    return this.config?.invalidTlds ?? [];
  }
}